export enum OwnerRoutes {
  Root = "",
  Integrations = "integrations",

  // The platform-wide settings that are not an integration credential (#608): the public base URL and the
  // register app's advertised version/build. It replaces the raw key→value editor that used to sit at
  // `/owner/environment` — `AppRoutes.OwnerEnvironmentSettings` and its component are gone, so that path now
  // falls through the owner module's catch-all to the dashboard.
  Platform = 'platform',

  ContractManager = 'contract-manager',

  /**
   * Rechtliches (#613/#631) — the owner-only fiscal setup of ONE location: its legal providers and its
   * technical security system. It is a page of its own rather than a step of the shard wizard, because
   * nothing on it is a form field: every control here is an irreversible action with its own confirmation,
   * and the wizard's "Weiter/Speichern" chrome promised a save that was never part of it.
   *
   * Takes `?shardId=` as a deep link, so the Standorte list can hand a location straight over.
   */
  Legal = 'legal',

  // accounts — the installation-wide account directory and the audited second-factor reset (#279/#282).
  // Platform-owner only: the listing enumerates every account across every tenant.
  AccountAdministration = 'accounts',

  // company
  CompanyCreate = 'company/create',
  CompanyOverview = 'company/overview',

  // shard
  ShardEdit = 'shard/edit',
}
